'use client';

import { Sheet, SheetContent, SheetTitle } from '@/components/ui/extended/sheet';
import { useEffect, useState } from 'react';
import RedeemedAmounts from './redeemed-amount';
export function RedeemedAmountSheet({
  open = false,
  onOpenChange
}: {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}) {
  const [isOpen, setIsOpen] = useState(open);
  useEffect(() => {
    setIsOpen(open);
  }, [open]);
  function handleOpenChange(status: boolean) {
    setIsOpen(status);
    onOpenChange?.(status);
  }
  return <Sheet open={isOpen} onOpenChange={handleOpenChange} data-sentry-element="Sheet" data-sentry-component="RedeemedAmountSheet" data-sentry-source-file="redeemed-amount-sheet.tsx">
      <SheetContent className=" md:w-[460px] 2xl:w-[600px] " data-sentry-element="SheetContent" data-sentry-source-file="redeemed-amount-sheet.tsx">
        <SheetTitle data-sentry-element="SheetTitle" data-sentry-source-file="redeemed-amount-sheet.tsx">
        </SheetTitle>
        <RedeemedAmounts onClick={() => handleOpenChange(false)} data-sentry-element="RedeemedAmounts" data-sentry-source-file="redeemed-amount-sheet.tsx" />
      </SheetContent>
    </Sheet>;
}